module.exports = __webpack_public_path__ + "static/olubunmi-873b95b580cbf24259412edf8bf0752c.jpg";